import {BaseInfo, BspLogistics, businessOrg, dhsAddress, DhsGoods} from '../resources';


export default {
  data() {
    return {
      upOrgList: [], // 货主
      downOrgList: [], // 来源单位
      callOrgList: [],
      dhsGoodsList: [], // dhs货品
      batchNumberList: [], // 批号
      factoryList: [], // 生产厂商
      upAddressList: [], // 货主仓库地址,
      downAddressList: [], // 来源单位仓库地址
      logisticsCenter: [], // 物流中心
      logisticsProviderList: [], //物流商
      bizOrgList: [] // 业务单位
    };
  },
  methods: {
    queryUpOrgList: function (query, success = () => {
    }) {// 查询货主
      BaseInfo.queryPager({keyWord: query}).then(res => {
        this.upOrgList = res.data.list;
        success();
      });
    },
    queryDownList: function (query, success = () => {
    }) {// 查询来源单位
      let params = {};
      if (typeof query === 'string') {
        params = {keyWord: query}
      } else if (typeof query === 'object') {
        params = query;
      }
      BaseInfo.queryPager(params).then(res => {
        this.downOrgList = res.data.list;
        success();
      });
    },
    queryDhsGoods(query, success = () => {
    }) {
      let params = {};
      if (typeof query === 'string') {
        params = {keyWord: query, deleteFlag: false}
      } else if (typeof query === 'object') {
        params = query;
      }
      DhsGoods.queryPager(params).then(res => {
        this.dhsGoodsList = res.data.list;
        success();
      });
    },
    queryManageGoods(query, success = () => {
    }) {
      this.$http({
        url: '/dhs-goods/operating-goods',
        method: 'post',
        params: {
          keyWord: query,
          deleteFlag: false
        },
        data: {}
      }).then(res => {
        this.dhsGoodsList = res.data.list;
        success();
      });
    },
    queryDhsBatchNumberList(query) {
      let params = {};
      if (typeof query === 'string') {
        params.keyWord = query;
      } else if (typeof query === 'object') {
        params = query;
      }
      let data = {};
      if (params.goodsId) {
        data.goodsId = params.goodsId;
      }
      data.batchStatus = '1';
      this.$http.post('/dhs-batch-number/pager', data, {
        params: {
          keyWord: params.keyWord
        }
      }).then(res => {
        this.batchNumberList = res.data.list;
      });
    },
    queryFactoryList(query) {
      // 过滤来源单位
      let params = {
        keyWord: query,
        orgRelationTypeList: ['1', '2', '3', '4', '5', '6', '7']
      };
      BaseInfo.queryByOrgRelationTypeList(params).then(res => {
        this.factoryList = res.data.list;
      });
    },
    queryUpAddressList(orgId, success = () => {
    }) {
      if (!orgId) return;
      dhsAddress.queryAddress(orgId, {
        deleteFlag: false,
        orgId: orgId,
        auditedStatus: '1'
      }).then(res => {
        this.upAddressList = res.data;
        success();
      });
    },
    queryDownAddressList(orgId, success = () => {
    }) {
      if (!orgId) return;
      dhsAddress.queryAddress(orgId, {
        deleteFlag: false,
        orgId: orgId,
        auditedStatus: '1'
      }).then(res => {
        this.downAddressList = res.data;
        success();
      });
    },
    queryLogisticsCenter(query, success = () => {
    }) {
      let params = {
        keyWord: query
      };
      BspLogistics.queryCurLogistics(params).then(res => {
        this.logisticsCenter = res.data;
        success();
      });
    },
    queryLogisticsProviderList(query, businessOrgId) {
      let params = {
        keyWord: query,
        orgId: this.$store.state.user.userCompanyAddress,
        businessOrgId,
        orgRelationTypeList: ['9']
      };
     return businessOrg.query(params).then(res => {
        this.logisticsProviderList = res.data.list.map(m => ({
          id: m.businessOrgId,
          name: m.businessOrgName,
          manufacturerCode: m.businessOrgManufacturerCode,
          creditCode: m.businessOrgCreditCode
        }));
      });
    },
    queryCallAllFactory(query) { // 查询回调单位
      let params = {
        keyWord: query
      };
      BaseInfo.query(params).then(res => {
        this.callOrgList = res.data.list;
      });
    },
    queryBizOrgList(query) {
      let params = {};
      if (typeof query === 'string') {
        params = {keyWord: query, deleteFlag: false}
      } else if (typeof query === 'object') {
        params = query;
      }
      businessOrg.query(params).then(res => {
        this.bizOrgList = res.data.list.map(m => ({
          id: m.businessOrgId,
          name: m.businessOrgName,
          manufacturerCode: m.businessOrgManufacturerCode,
          creditCode: m.businessOrgCreditCode
        }));
      });
    },
    queryUpBizOrgList(query) {
      let params = {};
      if (typeof query === 'string') {
        params = {keyWord: query, deleteFlag: false}
      } else if (typeof query === 'object') {
        params = query;
      }
      businessOrg.query(params).then(res => {
        this.upOrgList = res.data.list.map(m => ({
          id: m.businessOrgId,
          name: m.businessOrgName,
          manufacturerCode: m.businessOrgManufacturerCode,
          creditCode: m.businessOrgCreditCode
        }));
      });
    }
  }
};
